import React, { Fragment } from 'react';
import { Intro, WordBankSelect } from 'abbot-core';
import img from '../../assets/images/U1-T2-4-2.svg';

const data = {
  beforeSpace: '',
  afterSpace:
    ' is a noncommunicable disease in which fat builds up in the body’s arteries.',
  options: [
    {
      label: 'Type 2 Diabetes'
    },
    {
      label: 'Cancer'
    },
    {
      label: 'Heart Disease'
    },
    {
      label: 'Influenza (Flu)'
    },
    {
      label: 'High Blood Pressure'
    }
  ]
};

const correctInput = {
  [`${data.beforeSpace}${data.afterSpace}`]: data.options[2].label
};

const feedback = {
  success: {
    title: 'That’s right!',
    body: ''
  },
  error: {
    title: 'Incorrect.',
    body: ''
  },
  retry: {
    title: 'Not quite, give it another try',
    body: ''
  }
};

export default {
  title: 'Question 2',
  path: '/challenge/question-2',
  content: (
    <Fragment>
      <Intro
        title="Show What You Learned"
        direction="Select the word/phrase that best completes the sentence."
        img={img}
      />

      <WordBankSelect
        data={data}
        feedback={feedback}
        correctInput={correctInput}
        score={1}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/challenge/Question2.js